// eslint-disable
// this is an auto generated file. This will be overwritten

export const onCreateCanvas = `subscription OnCreateCanvas {
  onCreateCanvas {
    id
    clientId
    data
  }
}
`;
export const onUpdateCanvas = `subscription OnUpdateCanvas {
  onUpdateCanvas {
    id
    clientId
    data
  }
}
`;
export const onDeleteCanvas = `subscription OnDeleteCanvas {
  onDeleteCanvas {
    id
    clientId
    data
  }
}
`;
